export const MAPBOX_STYLE = 'mapbox://styles/mapbox/streets-v12';
